import { observer } from 'mobx-react-lite';
import { FooterContainer, FooterContent } from './footer.styles';
import FooterTop from './footer-top.component';
import FooterBottom from './footer-bottom.component';
import { useFooter } from './helpers/FooterContext';
import { useStore } from '../../stores/store';
import { mergeLinks } from './helpers/utils';
import { FooterLinks } from '../../models/footerLinksModel';

const Footer = () => {
  const { footerDisplayOption } = useFooter();
  const {
    localizationsStore: { selectedCountry },
    marketingStore: { getHardcodedFooterLinks },
  } = useStore();

  const links: FooterLinks | undefined = mergeLinks(
    selectedCountry?.links,
    getHardcodedFooterLinks(selectedCountry?.country_code)
  );

  if (footerDisplayOption === 'hidden') {
    return null;
  }

  return (
    <FooterContainer>
      {footerDisplayOption === 'full' && (
        <FooterContent>
          <FooterTop links={links} />
        </FooterContent>
      )}
      <FooterContent>
        <FooterBottom links={links} />
      </FooterContent>
    </FooterContainer>
  );
};

export default observer(Footer);
